<template>
  <div class="col-sm-12 nopads">
    <h3 class="text-center">
      {{ name }}
    </h3>
    {{ toLocalTime(data.data_updated_time) }}
    <div v-if="data.station && data.station.position" class="coordinate-map" >
      <marker-editor-map
        :lat="data.station.position.y"
        :lon="data.station.position.x"
        :type="WEATHER_STATION"
        :draggable="false"
      />
    </div>
    <table class="table table-sm">
      <thead>
      <tr>
          <th>{{ $t('weather_station.sensor_data.name') }}</th>
          <th>{{ $t('weather_station.sensor_data.value') }}</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(sensor, index) in sensorData" :key="index">
          <td>{{ sensor.name }}</td>
          <td v-if="sensor.name === 'SATEEN_OLOMUOTO_PWDXX'">{{ getRainTypeText(sensor.value) }}</td>
          <td v-else>{{ cleanValue(sensor.value) }} {{ cleanValue(sensor.unit) }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import {mapHelper} from "../mixins/MapMixin";
import {utility} from "@/components/mixins/Utils";
import {timeUtils} from "@/components/mixins/TimeUtils";
import MarkerEditorMap from "@/components/map/MarkerEditorMap";
import {weatherHelper} from "../mixins/WeatherMixin.js";

export default {
    name: "WeatherStationDataDetails",
    components: {MarkerEditorMap},
    mixins: [mapHelper, utility, timeUtils, weatherHelper],
    props: {
        data: {
            type: Object,
            default: null
        },
        name: {
            type: String,
            default: null
        }
    },
    computed: {
        sensorFields() {
            return [
                {key: 'name', label: this.$t('weather_station.sensor_data.name'), sortable: true},
                {key: 'value', label: this.$t('weather_station.sensor_data.value'), sortable: true},
            ]
        },
        sensorData() {
            let lang = this.getLanguage()
            const value = this.data.sensorValues === undefined ? this.data.sensor_values : this.data.sensorValues;
            return value.map(d => (
                {
                    name: d.name,
                    measuredTime: new Date(d.measured_time),
                    value: (d.sensor_value_description_fi && lang === "fi") ?
                        d.sensor_value_description_fi :
                        d.sensor_value_description_en ? d.sensor_value_description_en : d.value,
                    unit: d.sensor_value_description_en ? '' : d.unit
                }
            ))
        },
    },
    methods: {
        cleanValue(value) {
            if (typeof value !== "string") {
                value = String(value);
            }
            return value.replace(/###|\?\?\?|\/{3}|\*{3}/g, "");
        }
    }
}
</script>
